<script>
/* eslint-disable */
import Instruction from "./Instruction.vue";
import Draggable from "vuedraggable";
const setDragCursor = (value) => {
  const html = document.getElementsByTagName("html").item(0);
  html.classList.toggle("grabbing", value);
};
export default {
  props: ["group"],
  components: {
    Instruction,
    Draggable,
  },

  data() {
    return {
      isDrag: false,
      items: this.group ? this.group.instructions : [],
      g_name: this.group ? this.group.name : "",
      timeout: null,
      id: this.group ? this.group.id : null,
      status: this.group ? this.group.status : null,
    };
  },
  methods: {
    instructionSaved(e) {
      const items = JSON.parse(JSON.stringify(this.items));
      for (let i = 0; i < items.length; i++) {
        const currentItem = items[i];
        if (e.uuid === currentItem.id) {
          items[i].id = e.itemId;
          items[i].instruction = e.instruction;
        }
      }
      
      this.$store.commit(`recipes/updateInstruction`, {
        groupId: this.id,
        item: e
      });

      this.items = items;
    },
    addInstruction() {
      this.isDrag = false;
      this.$store.commit(
        "recipes/addInstructionToGroupCurrentRecipe",
        this.group.id
      );

      // const id =
      //   "instruction_item_" +
      //   this.group.instructions[this.group.instructions.length - 1].id;

      // setTimeout(() => {
      //   window.document.getElementById(id).focus();
      // }, 1);
    },
    createUpdateMethodGroup() {
      this.isDrag = false;
      const group = {
        id: this.id,
        g_name: this.g_name,
        group: this.group,
      };
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.status == "create") {
          this.$store
            .dispatch("recipes/createMethodGroup", group)
            .then((id) => {
              this.id = id;
              this.status = "added";
              this.$store.commit(`commons/setSavingForm`, "Saved");
            });
        } else {
          this.$store
            .dispatch("recipes/updateMethodGroup", group)
            .then((res) => {
              // // this.makeToast("success", "Success", `Succesfully saved.`);
              this.$store.commit(`commons/setSavingForm`, "Saved");
            });
        }
      }, 1000);
    },

    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    deleteGroup() {
      this.isDrag = false;
      this.$store.commit("commons/setPreloader", true);
      this.$store.dispatch("recipes/deleteMethodGroup", this.id).then((res) => {
        this.$store.commit(`commons/setSavingForm`, "Deleted");
        this.$store.commit("commons/setPreloader", false);
      });
    },

    onDragStart() {
      setDragCursor(true);
      this.isDrag = true;
    },
    onDragEnd() {
      setDragCursor(false);
    },
  },
  watch: {
    group(newGroup) {
      this.items = newGroup.instructions;
    },
    items(newItems) {
      setTimeout(() => {
        if (this.isDrag) {
          const newOrder = [];
          for (let i = 0; i < newItems.length; i++) {
            newOrder.push({
              position: i,
              id: newItems[i].id,
            });
          }
          newOrder.forEach((order) => {
            this.$store
              .dispatch("recipes/patchMethodGroupInstruction", order)
              .then((res) => {
                this.$store.commit(`commons/setSavingForm`, "Saved");
              });
          });
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.group-header {
  text-transform: uppercase;
  margin-bottom: 1rem;
}
.box-delete {
  display: flex;
  align-items: center;
}
.box-delete input {
  margin-right: 1rem;
}
.table-header {
  display: grid;
  grid-template-columns: 0.5fr 8fr 0.5fr;
  gap: 15px;
  margin-bottom: 0.5rem;
}
.auto {
  /* overflow-y: auto;
  max-height: 900px; */
  padding-bottom: 4rem;
}
.auto > div {
  counter-reset: my-awesome-counter;
}
.add-instruction {
  border-style: dashed;
  text-transform: uppercase;
}
</style>

<template>
  <div>
    <div class="group-header">
      <label>Instruction Group</label>
      <div class="box-delete">
        <b-form-input
          class="input"
          v-model="g_name"
          @keyup="createUpdateMethodGroup"
          :id="`instruction_` + group.id"
        ></b-form-input>
        <b-icon
          icon="trash"
          class="cursor-pointer"
          variant="danger"
          @click="deleteGroup"
        ></b-icon>
      </div>
    </div>
    <div class="table-header" v-if="group.items && group.items.length > 0">
      <div class="column"></div>
      <div class="column">Instruction</div>
      <div class="column"></div>
    </div>
    <div class="auto">
      <draggable v-model="items" @start="onDragStart" @end="onDragEnd">
        <instruction
          v-for="instruction of items"
          :key="instruction.id"
          :item="instruction"
          :position="instruction.position"
          :groupId="id"
          @instruction-saved="instructionSaved"
        ></instruction>
      </draggable>
      <div class="auto-add-group">
        <b-button
          variant="outline-success"
          class="add-instruction"
          block
          @click="addInstruction"
          :disabled="status == 'create'"
          >Add Instruction
        </b-button>
      </div>
    </div>
    <hr />
  </div>
</template>

